import { titleize, underscore } from 'inflected';
import { MergeFieldData } from '../model/merge.field.data';
import { getMergeSchema } from '../utilities/get.merge.schema';

export const MergeField = (options?: Partial<MergeFieldData>): PropertyDecorator => {
    return (target: any, propertyKey: string | symbol): void => {

        const meta = getMergeSchema(target);

        let displayName = titleize(propertyKey as string)
        // titleize() strips a trailing id token (taxId -> "Tax"); re-add " ID" only for real id
        // fields, not words merely ending in "id" (amountPaid -> "Amount Paid").
        if (underscore(propertyKey as string).endsWith('_id')) {
            displayName = `${displayName} ID`;
        }

        const field = {
            name: propertyKey,
            displayName: displayName,
            hidden: (propertyKey as string).startsWith('_'),
            ...options
        } as MergeFieldData;

        meta.fields.push(field);

    };
};